import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';
import PhoneMockup from '../common/PhoneMockup';
import Reveal from '../common/Reveal';
import SectionHead from '../common/SectionHead';
import FaqList from '../faq/FaqList';
import {
  StatusNote,
  Difference,
  HowItWorks,
  BuyersSellers,
  Features,
  Audiences,
  OperatingModel,
  PartnerBand,
} from './Sections';
import { useLang, usePageTitle } from '../../i18n/LanguageContext';

export default function SafeHand() {
  const { t } = useLang();
  usePageTitle(t.nav.safehand);
  const platformFaq = t.faq.groups[0];

  return (
    <>
      <PageHeader crumb={t.nav.safehand} eyebrow={t.hero.eyebrow} title={t.problem.answerTitle} lead={t.hero.lead}>
        <StatusNote />
      </PageHeader>

      <section className="section">
        <div className="container split">
          <Reveal className="split__copy">
            <p className="eyebrow">{t.problem.eyebrow}</p>
            <h2 className="section-title">{t.problem.title}</h2>
            <p className="section-lead">{t.problem.lead}</p>
            <ul className="checklist checklist--x">
              {t.problem.items.map((it) => (
                <li key={it.title}>
                  <i className="fa-solid fa-xmark" aria-hidden="true" />
                  <span>
                    <strong>{it.title}</strong> {it.text}
                  </span>
                </li>
              ))}
            </ul>
            <p className="split__answer">
              <i className="fa-solid fa-diagram-project" aria-hidden="true" /> {t.problem.answerText}
            </p>
          </Reveal>
          <Reveal delay={150} className="split__visual split__visual--tint">
            <PhoneMockup />
          </Reveal>
        </div>
      </section>

      <Difference />
      <HowItWorks />
      <BuyersSellers />
      <Features />
      <Audiences />
      <OperatingModel />

      <section className="section">
        <div className="container narrow">
          <SectionHead eyebrow={t.faq.eyebrow} title={platformFaq.title} />
          <FaqList items={platformFaq.items} idPrefix="sh" />
          <p className="center muted mt-4">
            <Link to="/faq" className="text-link">
              {t.faq.title} <i className="fa-solid fa-arrow-right flip-rtl" aria-hidden="true" />
            </Link>
          </p>
        </div>
      </section>

      <PartnerBand />
    </>
  );
}
